import { styled } from '@mui/system'
import { Button as Btn, Box } from '@mui/material'
import { MuiButton } from '../'

const commonIconButtonProps = (props) => {
  const isOutlined = props?.variant === 'outlined'
  const isContained = props?.variant === 'contained'
  const isText = props?.variant === 'text'
  const isDark = props?.color === 'dark'
  const isPrimary = props?.color === 'primary'
  const isSm = props?.size === 'sm'

  return `
    margin-left:10px;
    box-sizing: border-box;
    padding:0;
    border-radius: 4px;
    height: 35px; width: 35px;
    min-width: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    & svg path { fill: #686867; }

    &:hover {
      color: #095BBD;
      background: transparent;
      & svg path { fill: #095BBD; }
    }

    &:active {
      color: #686867;
      background: transparent;
      & svg path { fill: #686867; }
    }

    ${isText && `height: 30px; width: 30px; min-width: 30px; border:0; background:transparent;`};
    ${isSm && `height: 28px; width: 28px; padding:0;`};

    ${isOutlined && `border: 1px #D8D8D6 solid;`};
    ${isContained && `background:#fff; border: 1px #D8D8D6 solid;`};

    &:hover {
      ${isOutlined && `border-color: #095BBD;`};
      ${isContained && `border-color: #095BBD; background:#fff;`};
    }

    &:active {
      ${isOutlined && `border-color: #686867;`};
      ${isContained && `border-color: #686867; background:#fff;`};
    }
    & span { margin:0; }

    // border-bottom: 1px red solid;
  `
}

export const IconButton = styled(Btn)(
  (props) => `
  ${commonIconButtonProps(props)}
`
)

const commonButtonProps = (props) => {
  const isOutlined = props?.variant === 'outlined'
  const isContained = props?.variant === 'contained'
  const isDark = props?.color === 'dark'
  const isGray = props?.color === 'gray'
  const isPrimary = props?.color === 'primary'
  const isSm = props?.size === 'sm'

  return `
    margin-left:10px;
    box-sizing: border-box;
    padding:10px 14px;
    border-radius: 4px;
    min-width: 10px;
    display: flex;
    justify-content: center;
    height: 35px;
    line-height: 1;
    color: #686867;

    &:hover {
      color: #095BBD;
      background: transparent;
      & svg path { fill: #095BBD; }
    }
    
    &:active {
      color: #686867;
      background: transparent;
      & svg path { fill: #686867; }
    }

    ${isSm && `height: 28px; padding-top:0; padding-bottom:0;`};

    ${isOutlined && `border: 1px #D8D8D6 solid;`};
    ${isContained && isPrimary && `color: #fff;`};
    ${isOutlined && isDark && `background: transparent; color: #000; border:1px #000 solid; & svg path { fill: #000; };`};
    ${isContained && isDark && `background: #000; color: #fff; & svg path { fill: #fff; };`};

    &:hover {
      ${isOutlined && `border-color: #095BBD;`};
      ${isContained && isPrimary && `color: #fff; background: #000; & svg path { fill: #fff; }`};
      ${isOutlined && isDark && `background: transparent; color: #095BBD; border-color:#095BBD;`};
      ${isContained && isDark && `background: #095BBD; color: #fff; & svg path { fill: #fff; };`};
    }
    
    &:active {
      ${isOutlined && `border-color: #686867;`};
      ${isContained && isPrimary && `color: #fff; background: #063D7E`};
      ${isOutlined && isDark && `background: #E4EEFB; color: #095BBD; border-color:#095BBD;`};
      ${isContained && isDark && `background: #063D7E; color: #fff; & svg path { fill: #fff; };`};
    }

    & span { margin:0; }
    & span.MuiButton-startIcon { margin-right:6px; }
    // border-bottom: 1px red solid;
  `
}

export const Button = styled(Btn)(
  (props) => `
  ${commonButtonProps(props)};
`
)

export const LinkButton = styled(MuiButton)(
  (props) => `
  ${commonButtonProps(props)};
`
)
